import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_claim_account_balance_RowClass} from '../../../dbschema';

export class ClaimAccountBalanceContainerModel extends BaseContainerModel {
  bl_aat_claim_account_balance: bl_aat_claim_account_balance_RowClass = new bl_aat_claim_account_balance_RowClass();
}
